module.exports = __webpack_public_path__ + "img/port1.def1a7e7.png";